import React, { useEffect, useState, useRef } from "react"
import { Button, Card, Checkbox, Collapse, Divider, Icon, Input, InputGroup, InputLeftElement, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay, Select, Slide, Stack, StackDivider, Tab, TabList, TabPanel, TabPanels, Tabs, Tag, Textarea, effect, useDisclosure, useColorMode } from "@chakra-ui/react"
import { InfoOutlineIcon, Search2Icon } from "@chakra-ui/icons";
import { CheckCourse } from "./CheckCourse";
import { Link } from "react-router-dom";
import { LeaveApplicationHelper } from "../../dal/leave_application_helper";
import { ReturnReasonHelper } from "../../dal/return_reason_helper";
import { Util } from "../../dal/util";
import { StuLeaveAppDetail } from "../../components/StuLeaveAppDetail";
import { WaitingApprove } from "./WaitingApprove";
import { OfficialDetail } from "./OfficialDetail";
import { StuOfficialDetail } from "../../components/StuOfficialDetail";
import { SemesterStrInfo } from "../../dal/value_object";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";
import { use } from "i18next";


export const TeacherApprove = () => {
  const { onOpen, onClose, isOpen, onToggle } = useDisclosure();
  const { isOpen: isRuleOpen, onOpen: onRuleOpen, onClose: onRuleClose } = useDisclosure();
  const { isOpen: isWithdrawOpen, onOpen: onWithdrawOpen, onClose: onWithdrawClose } = useDisclosure();
  const { getButtonProps, getDisclosureProps } = useDisclosure({ defaultIsOpen: true });
  const { t, i18n } = useTranslation("translation");

  // const isScreenSmall = () => window.innerWidth < 640;
  const [applyButtonProps, setApplyButtonProps] = useState(window.innerWidth < 640);
  const buttonProps = getButtonProps();
  const disclosureProps = getDisclosureProps();

  const [leaveApplications, setLeaveApplications] = useState<any[]>([]); // 從資料庫中取得的紀錄
  const [selectedLeaveApplication, setSelectedLeaveApplication] = useState<any>(); //UI介面選擇的請假單
  const [prevLeaveApps, setPrevLeaveApps] = useState<any[]>([]); // 學生先前請假紀錄
  const [showDetailPanel, setShowDetailPanel] = useState<boolean>(false);
  const [reload, setReload] = useState(0);

  const [selectedTab, setSelectedTab] = useState<number>(0);
  const { colorMode, setColorMode } = useColorMode();

  const [semesters, setSemesters] = useState<SemesterStrInfo[]>([]);
  // 選擇的學年度學期
  const [selectedSemester, setSelectedSemester] = useState<SemesterStrInfo>(semesters[0]);
  // 狀態
  const [offset, setOffset] = useState(0);
  const limit = 50; // 每次載入 50 筆
  const [hasMore, setHasMore] = useState<boolean | undefined>(undefined);
  const [loading, setLoading] = useState<boolean | undefined>(undefined);
  const [dispFirstLeaveApp, setDispFirstLeaveApp] = useState(false);  // 顯示在畫面上的第一筆假單
  const [reloadKey, setReloadKey] = useState(0); // 每次切 tab 都 +1
  const [keyword, setKeyword] = useState<string>('');
  const [comment, setComment] = useState<string>('');
  const [reason, setReason] = useState<any[]>([]);
  const [reasonLoading, setReasonLoading] = useState<boolean | undefined>(undefined);
  const [textareaValue, setTextareaValue] = useState<string>("");
  const textareaRef = useRef<HTMLTextAreaElement>(null);

  useEffect(() => {
    loadReason();
  }, []);

  const loadReason = async () => {
    setReasonLoading(true);
    const reason = await ReturnReasonHelper.getReturnReason();
    setReasonLoading(false);
    setReason(reason);
  }
  const handleReasonClick = (text: string) => {
    // const newText = textareaValue + (textareaValue ? "\n" : "") + text;
    const newText = textareaValue + text;
    setTextareaValue(newText);
    setComment(newText);

    // 滾動到textarea底部
    setTimeout(() => {
      textareaRef.current?.scrollTo({ top: textareaRef.current.scrollHeight, behavior: "smooth" });
    }, 0);
  };

  const handleTextareaChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    setTextareaValue(event.target.value);
    setComment(event.target.value);
  };
  const handleRejectClose = () => {
    setComment('');
    setTextareaValue('');
  };

  //監聽視窗大小
  useEffect(() => {
    setColorMode('light');
    const handleResize = () => {
      setApplyButtonProps(window.innerWidth < 768);
    };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };

  }, []);

  useEffect(() => {
    setOffset(0);
    setHasMore(true);
    setLeaveApplications([]); // 避免舊資料一閃而過
    setReloadKey(prev => prev + 1); // 強制觸發 loadData
  }, [selectedTab, selectedSemester]);


  useEffect(() => {
    if (offset === 0) {
      console.log({ offset, reloadKey });
      loadData(0);
    }
  }, [offset, reloadKey]);

  useEffect(() => {
    if (reload == 1) {
      loadData(1);
      setReload(0);
    }
    else if (reload == 2) {
      loadData(0);
      setReload(0);
    }
  }, [reload]);


  const loadData = async (mode: number) => {
    if (selectedTab === 0) {  //載入等待審核的假單
      setLoading(true);
      const apps_waiting_approved = await LeaveApplicationHelper.getTeacherWaitingApprovedList();
      // console.log( { apps_waiting_approved });
      const sorted = Util.reSortLeaveApp(apps_waiting_approved);
      setLoading(false);
      setLeaveApplications(sorted);
      if (mode === 0) // 不顯示第一筆假單        
      {
        setSelectedLeaveApplication(null)
        setDispFirstLeaveApp(false);
      }
      else {
        setSelectedLeaveApplication(sorted[0]);
        setDispFirstLeaveApp(true);
      }
    }
    if (selectedTab === 1) {

      /** 載入教師審核過假單的學期 */
      const semesters: SemesterStrInfo[] = await LeaveApplicationHelper.getTeacherHistoriesSemester();
      setSemesters(semesters);

      if (semesters.length > 0) {
        /** 載入教師審核過的假單 */
        const semesterParam = selectedSemester ? selectedSemester : semesters[0];
        console.log({ semesterParam }, offset, limit);
        setLoading(true);
        const records = await LeaveApplicationHelper.getTeacherApprovedList(semesterParam, offset, limit);

        const sorted = Util.reSortLeaveApp(records);
        setLeaveApplications(prev => {
          console.log({ prev, mode, sorted });
          return mode === 0 ? sorted : [...prev, ...sorted];
        });

        //setLeaveApplications(prev => mode === 0 ? sorted : [...prev, ...sorted]);
        setLoading(false);
        if (mode === 0) {
          setSelectedLeaveApplication(null);
        }
        setOffset(prev => prev + limit);
        setHasMore((records?.length ?? 0) === limit);
      }
      /** 載入教師審核過的假單 */
      // const records = await LeaveApplicationHelper.getTeacherAllApprovedList();
      // const sorted=Util.reSortLeaveApp(records);

      // setLeaveApplications(sorted);
      // setSelectedLeaveApplication(null);
    }
    if (selectedTab === 2) {  //載入公假申請的假單
      setLoading(true);
      const records = await LeaveApplicationHelper.getTeacherPublicLeaveApplicationList();
      setLeaveApplications(records);
      setSelectedLeaveApplication(records[0]);
      setLoading(false);
    }
  }
  const handleSemesterChange = (semester: SemesterStrInfo) => {
    console.log({ handleSemesterChange: semester });
    setSelectedSemester(semester);
  };
  const handleLoadMore = () => {
    loadData(1);
  };
  const handleShowDetail = (sw: boolean) => {
    if (sw) {
      applyButtonProps && setShowDetailPanel(true);
    }
  }

  const handleSelectedTab = (index: number) => {
    console.log({ index });
    setSelectedTab(index);
  }

  const loadPrevLeaveApps = async () => {
    if (selectedLeaveApplication) {
      const dateRange = Util.generateDateRange(selectedLeaveApplication.leaveDateAndPeriod[0].d, 7, 2);
      const stuid = selectedLeaveApplication.leaveStudents[0].studentID;
      const prevApps = await LeaveApplicationHelper.getStudentHistoriesByDateRange(stuid, dateRange.startDate, dateRange.endDate);
      const sorted = Util.reSortLeaveAppByStartDateAndDays(prevApps);
      const filtered = sorted.filter((lapp: any) => lapp.id !== selectedLeaveApplication.id);

      setPrevLeaveApps(filtered);
    }
  }

  useEffect(() => {
    loadPrevLeaveApps();
  }, [selectedLeaveApplication]);
  useEffect(() => {
    console.log({ TES: comment, textareaValue });
  }, [comment, textareaValue]);

  return (
    <>
      <div className="flex justify-start xl:justify-center overflow-hidden h-screen bg-[#d2e5f4]">
        <div {...disclosureProps} className={`bg-slate-100 myanim ${showDetailPanel ? 'w0' : ''} `} >
          <div className="App min-w-[22.5rem] w-screen max-w-full md:max-w-[22.5rem] p-4">
            <div id="teach-tabs" className=''>
              <Tabs isFitted variant='enclosed'>
                <TabList mb='1em' className='!grid grid-cols-2 gap-x-4'>
                  <Tab onClick={() => handleSelectedTab(0)}>
                    <svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlnsXlink="http://www.w3.org/1999/xlink" width="20" height="20" x="0" y="0" viewBox="0 0 465.2 465.2" xmlSpace="preserve" className="flex-shrink-0"><g><path d="M279.591 423.714a192.461 192.461 0 0 1-11.629 2.52c-10.148 1.887-16.857 11.647-14.98 21.804a18.651 18.651 0 0 0 7.618 11.876 18.64 18.64 0 0 0 14.175 3.099 233.175 233.175 0 0 0 13.854-3.008c10.021-2.494 16.126-12.646 13.626-22.662-2.494-10.025-12.637-16.125-22.664-13.629zM417.887 173.047a18.644 18.644 0 0 0 6.97 9.398c4.684 3.299 10.813 4.409 16.662 2.475 9.806-3.256 15.119-13.83 11.875-23.631a232.327 232.327 0 0 0-4.865-13.314c-3.836-9.59-14.714-14.259-24.309-10.423-9.585 3.834-14.256 14.715-10.417 24.308a194.816 194.816 0 0 1 4.084 11.187zM340.36 397.013a195.86 195.86 0 0 1-10.134 6.261c-8.949 5.162-12.014 16.601-6.854 25.546a18.664 18.664 0 0 0 5.416 5.942c5.769 4.059 13.604 4.667 20.127.909a233.049 233.049 0 0 0 12.062-7.452c8.614-5.691 10.985-17.294 5.291-25.912-5.693-8.621-17.291-10.989-25.908-5.294zM465.022 225.279c-.407-10.322-9.101-18.356-19.426-17.953-10.312.407-18.352 9.104-17.947 19.422.155 3.945.195 7.949.104 11.89-.145 6.473 3.021 12.243 7.941 15.711a18.647 18.647 0 0 0 10.345 3.401c10.322.229 18.876-7.958 19.105-18.285.103-4.709.064-9.48-.122-14.186zM414.835 347.816c-8.277-6.21-19.987-4.524-26.186 3.738a195.193 195.193 0 0 1-7.434 9.298c-6.69 7.86-5.745 19.666 2.115 26.361.448.38.901.729 1.371 1.057 7.814 5.509 18.674 4.243 24.992-3.171a232.358 232.358 0 0 0 8.874-11.102c6.2-8.262 4.522-19.98-3.732-26.181zM442.325 280.213c-9.855-3.09-20.35 2.396-23.438 12.251a198.06 198.06 0 0 1-3.906 11.253c-3.105 8.156-.13 17.13 6.69 21.939a18.635 18.635 0 0 0 4.126 2.19c9.649 3.682 20.454-1.159 24.132-10.812a240.351 240.351 0 0 0 4.646-13.382c3.085-9.857-2.397-20.349-12.25-23.439zM197.999 426.402a193.1 193.1 0 0 1-47.968-15.244c-.18-.094-.341-.201-.53-.287a204.256 204.256 0 0 1-10.63-5.382c-.012-.014-.034-.023-.053-.031a199.491 199.491 0 0 1-18.606-11.628C32.24 331.86 11.088 209.872 73.062 121.901c13.476-19.122 29.784-35.075 47.965-47.719.224-.156.448-.311.67-.468 64.067-44.144 151.06-47.119 219.089-1.757l-14.611 21.111c-4.062 5.876-1.563 10.158 5.548 9.518l63.467-5.682c7.12-.64 11.378-6.799 9.463-13.675L387.61 21.823c-1.908-6.884-6.793-7.708-10.859-1.833l-14.645 21.161C312.182 7.638 252.303-5.141 192.87 5.165a235.263 235.263 0 0 0-17.709 3.78c-.045.008-.081.013-.117.021-.225.055-.453.128-.672.189-51.25 13.161-95.965 43.052-127.872 85.7-.269.319-.546.631-.8.978a220.276 220.276 0 0 0-3.145 4.353 229.217 229.217 0 0 0-4.938 7.308c-.199.296-.351.597-.525.896C10.762 149.191-1.938 196.361.24 244.383c.005.158-.004.317 0 .479a227.87 227.87 0 0 0 1.088 14.129c.027.302.094.588.145.89a230.909 230.909 0 0 0 1.998 14.145c8.344 48.138 31.052 91.455 65.079 125.16.079.079.161.165.241.247.028.031.059.047.086.076a235.637 235.637 0 0 0 29.793 24.898c28.02 19.744 59.221 32.795 92.729 38.808 10.167 1.827 19.879-4.941 21.703-15.103 1.823-10.169-4.939-19.889-15.103-21.71z" fill="#2b6cb0" opacity="1" data-original="#000000"></path><path d="M221.124 83.198c-8.363 0-15.137 6.78-15.137 15.131v150.747l137.87 71.271a15.042 15.042 0 0 0 6.933 1.69c5.476 0 10.765-2.982 13.454-8.185 3.835-7.426.933-16.549-6.493-20.384L236.244 230.65V98.329c-.001-8.351-6.767-15.131-15.12-15.131z" fill="#2b6cb0" opacity="1" data-original="#000000"></path></g></svg>
                    <div className="ms-2 whitespace-nowrap">{t("app.pending_approve")}</div>
                  </Tab>
                  <Tab onClick={() => setSelectedTab(1)}>
                    <svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlnsXlink="http://www.w3.org/1999/xlink" width="20" height="20" x="0" y="0" viewBox="0 0 438.891 438.891" xmlSpace="preserve" className="flex-shrink-0"><g><path d="M347.968 57.503h-39.706V39.74c0-5.747-6.269-8.359-12.016-8.359h-30.824C258.108 10.483 239.822.034 218.924.034c-20.668-.777-39.467 11.896-46.498 31.347h-30.302c-5.747 0-11.494 2.612-11.494 8.359v17.763H90.923c-23.53.251-42.78 18.813-43.886 42.318v299.363c0 22.988 20.898 39.706 43.886 39.706h257.045c22.988 0 43.886-16.718 43.886-39.706V99.822c-1.106-23.506-20.356-42.068-43.886-42.319zm-196.441-5.224h28.735a11.496 11.496 0 0 0 9.927-9.404c3.094-13.474 14.915-23.146 28.735-23.51 13.692.415 25.335 10.117 28.212 23.51a11.494 11.494 0 0 0 10.449 9.404h29.78v41.796H151.527V52.279zm219.429 346.906c0 11.494-11.494 18.808-22.988 18.808H90.923c-11.494 0-22.988-7.314-22.988-18.808V99.822c1.066-11.964 10.978-21.201 22.988-21.42h39.706v26.645c.552 5.854 5.622 10.233 11.494 9.927h154.122a11.493 11.493 0 0 0 12.016-9.927V78.401h39.706c12.009.22 21.922 9.456 22.988 21.42v299.364z" fill="#2b6cb0" opacity="1" data-original="#000000"></path><path d="M179.217 233.569c-3.919-4.131-10.425-4.364-14.629-.522l-33.437 31.869-14.106-14.629c-3.919-4.131-10.425-4.363-14.629-.522a10.971 10.971 0 0 0 0 15.151l21.42 21.943a9.403 9.403 0 0 0 7.314 3.135 10.446 10.446 0 0 0 7.314-3.135l40.751-38.661c4.04-3.706 4.31-9.986.603-14.025a8.78 8.78 0 0 0-.601-.604zM329.16 256.034H208.997c-5.771 0-10.449 4.678-10.449 10.449s4.678 10.449 10.449 10.449H329.16c5.771 0 10.449-4.678 10.449-10.449s-4.678-10.449-10.449-10.449zM179.217 149.977c-3.919-4.131-10.425-4.364-14.629-.522l-33.437 31.869-14.106-14.629c-3.919-4.131-10.425-4.364-14.629-.522a10.971 10.971 0 0 0 0 15.151l21.42 21.943a9.403 9.403 0 0 0 7.314 3.135 10.446 10.446 0 0 0 7.314-3.135l40.751-38.661c4.04-3.706 4.31-9.986.603-14.025a8.78 8.78 0 0 0-.601-.604zM329.16 172.442H208.997c-5.771 0-10.449 4.678-10.449 10.449s4.678 10.449 10.449 10.449H329.16c5.771 0 10.449-4.678 10.449-10.449s-4.678-10.449-10.449-10.449zM179.217 317.16c-3.919-4.131-10.425-4.363-14.629-.522l-33.437 31.869-14.106-14.629c-3.919-4.131-10.425-4.363-14.629-.522a10.971 10.971 0 0 0 0 15.151l21.42 21.943a9.403 9.403 0 0 0 7.314 3.135 10.446 10.446 0 0 0 7.314-3.135l40.751-38.661c4.04-3.706 4.31-9.986.603-14.025a9.253 9.253 0 0 0-.601-.604zM329.16 339.626H208.997c-5.771 0-10.449 4.678-10.449 10.449s4.678 10.449 10.449 10.449H329.16c5.771 0 10.449-4.678 10.449-10.449s-4.678-10.449-10.449-10.449z" fill="#2b6cb0" opacity="1" data-original="#000000"></path></g></svg>
                    <div className="ms-2 whitespace-nowrap">{t("app.approval_records")}</div>
                  </Tab>
                  {/*<Tab className='flex-col' onClick={() =>  setSelectedTab(2)}>
                    <div>公假申請</div>
                  </Tab> */}
                </TabList>
              </Tabs>

            </div>
            {selectedTab === 0 && <WaitingApprove WaitApproveLeaveApp={leaveApplications} setSelectedLeaveApp={setSelectedLeaveApplication} handleShowDetail={handleShowDetail} setReload={setReload} activateFirst={dispFirstLeaveApp} loading={loading}
              reason={reason}
              reasonLoading={reasonLoading}
              textareaValue={textareaValue}
              textareaRef={textareaRef}
              handleReasonClick={handleReasonClick}
              handleTextareaChange={handleTextareaChange}
              handleRejectClose={handleRejectClose}
              setComment={setComment}
              comment={comment}
              onKeywordChange={(keyword) => setKeyword(keyword)}
            />}
            {selectedTab === 1 && <CheckCourse ApproveHistoryLeaveApp={leaveApplications} setSelectedLeaveApp={setSelectedLeaveApplication} handleShowDetail={handleShowDetail}
              semesters={semesters}
              onSemesterChange={handleSemesterChange}
              hasMore={hasMore}
              onLoadMore={handleLoadMore}
              loading={loading}
            />}
            {selectedTab === 2 && <OfficialDetail OfficialLeaveApp={leaveApplications} setSelectedLeaveApp={setSelectedLeaveApplication} handleShowDetail={handleShowDetail} />}
          </div>
        </div>
        {(selectedTab === 0 || selectedTab === 1) &&
          <StuLeaveAppDetail
            selectedLeaveApp={selectedLeaveApplication}
            setShowDetailPanel={setShowDetailPanel}
            setReload={setReload}
            prevLeaveApps={prevLeaveApps}
            disButtons={(selectedTab === 0) ? false : true}
            reason={reason}
            reasonLoading={reasonLoading}
            textareaValue={textareaValue}
            textareaRef={textareaRef}
            handleReasonClick={handleReasonClick}
            handleTextareaChange={handleTextareaChange}
            handleRejectClose={handleRejectClose}
            comment={comment}
            keyword={keyword}
          />}
        {selectedTab === 2 && <StuOfficialDetail />}
      </div>
    </>
  )
}